import * as React from 'react';
import {useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Paper, TextField} from '@mui/material';
import Button from '@mui/material/Button';
import {useAppTranslation} from 'services/i18n';

/** what the queue can file: a completed course, or a request for one */
const COMPLETION = 'course_completion';
const REQUEST = 'request';

/**
 * The two halves of the agenda are filed on different screens, so Add has to
 * ask which one first -- the design does it with a single Type select.
 */
export const ApprovalCreateTypeDialog = ({onClose}: { onClose: () => void }) => {
    const t = useAppTranslation();
    const [type, setType] = useState(COMPLETION);

    return <Dialog open={true} onClose={onClose} PaperComponent={Paper} fullWidth maxWidth={'xs'}>
        <DialogTitle>{t('approvals.create.title')}</DialogTitle>
        <DialogContent>
            <TextField select fullWidth variant={'standard'} margin={'dense'}
                label={t('approvals.create.type')}
                value={type}
                onChange={(e) => setType(e.target.value)}>
                <MenuItem value={COMPLETION}>{t('approvals.type.course_completion')}</MenuItem>
                <MenuItem value={REQUEST}>{t('approvals.create.request')}</MenuItem>
            </TextField>
        </DialogContent>
        <DialogActions sx={{padding: '16px'}}>
            <Button color={'inherit'} onClick={onClose}>{t('form.cancel')}</Button>
            <Button color={'primary'} variant={'contained'}
                onClick={() => {
                    window.location.href = type === REQUEST
                        ? '#/approvals/new?type=request'
                        : '#/approvals/new';
                }}>{t('approvals.create.confirm')}</Button>
        </DialogActions>
    </Dialog>;
};
